import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { UiLoyaltyInformerCount } from '@/fo/ui/loyalty/informer/count';
import { Label, MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './PriceInfo.styles';

interface PriceInfoProps
  extends Pick<
    MappedProduct,
    | 'basePrice'
    | 'finalPrice'
    | 'stockStatus'
    | 'bonusPoints'
    | 'bonusPointsMax'
  > {
  isAuthorized: boolean;
  bonusLabel: Label['name'];
}

export function PriceInfo({
  basePrice,
  finalPrice,
  stockStatus,
  bonusPoints,
  bonusPointsMax,
  isAuthorized,
  bonusLabel
}: PriceInfoProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      {stockStatus === 'IN_STOCK' && (
        <>
          {basePrice !== null && basePrice > 0 && (
            <UiKitPriceBase
              value={finalPrice ?? basePrice}
              oldValue={finalPrice ? basePrice : null}
              className={slots.price()}
            />
          )}
          {bonusPointsMax > 0 && (
            <div className={slots.loyalty()}>
              <UiLoyaltyInformerCount
                isAuthorized={isAuthorized}
                bonuses={bonusPoints}
                bonusesMax={bonusPointsMax}
                label={bonusLabel}
                showLogin={false}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
